

const BASIC_DESCRIPTION = 'basic-description'
const TRANSACTION_RESOURCE_CENTER_DESCRIPTION = 'transaction-resource-center-description'
const PRODUCT_RESOURCE_CENTER_DESCRIPTION = 'product-resource-center-description'
const JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION = 'job-employment-resource-center-description'
const CURRENCY_EXCHANGE_RESOURCE_CENTER_DESCRIPTION = 'currency-exchange-resource-center-description'
const DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_CENTER_DESCRIPTION = 'digital-currency-alternative-resource-center-description'

const TRANSACTION_PROMOTION = 'transaction'
const PRODUCT_RESOURCE_PROMOTION = 'product-resource'
const JOB_EMPLOYMENT_RESOURCE_PROMOTION = 'job-employment'
const CURRENCY_EXCHANGE_RESOURCE_POMOTION = 'currency-exchange'
const DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_PROMOTION = 'digital-currency-alternative'


export {
  BASIC_DESCRIPTION,
  TRANSACTION_RESOURCE_CENTER_DESCRIPTION,
  PRODUCT_RESOURCE_CENTER_DESCRIPTION,
  JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION,
  CURRENCY_EXCHANGE_RESOURCE_CENTER_DESCRIPTION,
  DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_CENTER_DESCRIPTION,

  TRANSACTION_PROMOTION,
  PRODUCT_RESOURCE_PROMOTION,
  JOB_EMPLOYMENT_RESOURCE_PROMOTION,
  CURRENCY_EXCHANGE_RESOURCE_POMOTION,
  DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_PROMOTION
}

